import React, { useEffect } from "react";
import {
  WrapperAllFiles,
  FileIcon,
  WrapperPathMapSpan,
  FileTitle,
  FileBox,
  WrapperPathMapLi,
  WrapperPathMapUl,
  useStyles,
} from "./style";
import HtmlTooltip from "@mui/material/Tooltip";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import { getDocumentPermissions } from "../../../../store/document/actions";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import {
  postDocDownload,
  postFolderDownloadZip,
} from "../../../../store/explorer/actions";
import { confirmAlert } from "react-confirm-alert";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../../helpers/dateUtils";
import TextField from "@material-ui/core/TextField";
import { toast } from "react-toastify";
import iconFolder from "../../../../assets/yellow.svg";
import IconButton from "@mui/material/IconButton";
import filePdf from "../../../../assets/file-pdf.png";
import fileWord from "../../../../assets/file-word.png";
import fileExcel from "../../../../assets/file-excel.png";
import fileImage from "../../../../assets/file-jpg.png";
import fileZip from "../../../../assets/file-zip.png";
import fileDoc from "../../../../assets/file-doc.png";
import fileOther from "../../../../assets/file-other.png";
import folderGray from "../../../../assets/folder_gray.svg";
import reviewal from "../../../../store/dashboard/reducer";
import reviewalIcon from "../../../../assets/blue.svg";
import openIcon from "../../../../assets/open.svg";
import openLocationIcon from "../../../../assets/openLocation.svg";
import docAssistantIcon from "../../../../assets/docAssistant.svg";
import downloadIcon from "../../../../assets/download.svg";
import moveIcon from "../../../../assets/move.svg";
import shareIcon from "../../../../assets/share.svg";
import renameIcon from "../../../../assets/rename.svg";

import reprocessIcon from "../../../../assets/reprocess.svg";

import propertiesIcon from "../../../../assets/properties.svg";
import deleteIcon from "../../../../assets/delete.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import { Nb_DocumentCard } from "../../../../components/documentCard/documentCard";
import OptionMenuDocPlace from "../files/optionsMenu";
import Drawer from "@material-ui/core/Drawer";
import MoveDocPlace from "../files/move";
import ShareDocPlace from "../files/share";
import RenameDocPlace from "../files/raname";
import ReprocessDocPlace from "../files/reprocess";
import RecoverDocPlace from "../files/recover";
import {
  Container,
  ContainerIcon,
  ContainerImg,
  DocumentName,
  Image,
} from "./stylefx";
import Dropzone from "react-dropzone";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";

import { icon } from "@fortawesome/fontawesome-svg-core";

let deleteWord = "";

export function AllFilesDocPlace(props) {
  const { showAllFiles, toggleShowAllFiles, targetFileId } = props;
  const { loadingSearch, searchQuery } = props;

  // Add CSS for target file highlighting
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .target-file-highlight {
        background-color: #E3F2FD !important;
        border: 2px solid #2196F3 !important;
        border-radius: 8px !important;
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3) !important;
        position: relative !important;
        z-index: 10 !important;
      }
      
      .target-file-highlight::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, #2196F3, #21CBF3, #2196F3);
        border-radius: 10px;
        z-index: -1;
        animation: border-glow 2s ease-in-out infinite alternate;
      }
      
      @keyframes border-glow {
        0% { opacity: 0.5; }
        100% { opacity: 1; }
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const classes = useStyles();
  const viewMode = props.viewMode;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [item, setItem] = React.useState(0);
  const [showOption, setShowOption] = React.useState(false);
  const [showOption2, setShowOption2] = React.useState(false);
  const [showMove, setShowMove] = React.useState(false);
  const [showShare, setShowShare] = React.useState(false);
  const [showRename, setShowRename] = React.useState(false);
  const [showReprocess, setShowReprocess] = React.useState(false);
  const [showRecover, setShowRecover] = React.useState(false);

  const [showNewFolder, setShowNewFolder] = React.useState(false);
  const [totalFiles, setTotalFiles] = React.useState([]);

  // Context menu state for blank area right-click
  const [contextMenu, setContextMenu] = React.useState(null);
  const fileInputRef = React.useRef(null);
  const [updateAllFiles, setUpdateAllFiles] = React.useState(false);
  const [closeUploadFiles, setCloseUploadFiles] = React.useState(false);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage);
  const [permissions, setPermissions] = React.useState(false);
  const [isTrash, setIsTrash] = React.useState(false);
  const [mapLast3, setMapLast3] = React.useState([]);
  const { isSearchResults } = props;
  const [reset, setReset] = React.useState(props.reset);
  const [mapPath, setMapPath] = React.useState(props.mapPath);

  const { responseDocDownload, loadingDocDownload } = useSelector((state) => ({
    responseDocDownload: state.Explorer.responseDocDownload,
    loadingDocDownload: state.Explorer.loadingDocDownload,
  }));
  const { responseDocumentPermissions, loadingDocumentPermissions } =
    useSelector((state) => ({
      responseDocumentPermissions:
        state.DetailFolder.responseDocumentPermissions,
      loadingDocumentPermissions: state.DetailFolder.loadingDocumentPermissions,
    }));

  const { loadingFolderDownload } = useSelector((state) => ({
    loadingFolderDownload: state.Explorer.loadingFolderDownload,
  }));

  useEffect(() => {
    setCloseUploadFiles(props.closeUp);
    if (props.closeUp) {
      setTotalFiles([]);
    }
  }, [props.closeUp]);

  useEffect(() => {
    setIsTrash(props.isTrash);
  }, [props.isTrash]);

  useEffect(() => {
    let newMap = [];
    if (props.mapPath && props.mapPath.length > 0) {
      newMap = props.mapPath.slice(Math.max(props.mapPath.length - 3, 1));
    }

    setMapLast3(newMap);
    setMapPath(props.mapPath);
  }, [props.mapPath]);

  useEffect(() => {
    if (page > 0 && page * rowsPerPage >= props.limit) {
      setPage(Math.max(0, Math.floor((props.limit - 1) / rowsPerPage)));
    }
  }, [props.limit, page, rowsPerPage]);

  useEffect(() => {
    setRowsPerPage(props.rowsPerPage);
  }, [props.rowsPerPage]);

  useEffect(() => {
    if (responseDocDownload) {
      const blob = new Blob([responseDocDownload], {
        type: "application/octetstream",
      });
      const link = document.createElement("a");
      // create a blobURI pointing to our Blob
      const lastIndex = item?.fkArchive?.name?.lastIndexOf(".");
      const nameSplit = item?.fkArchive
        ? item?.fkArchive?.name?.slice(0, lastIndex)
        : "";
      link.href = URL.createObjectURL(blob);
      link.download = item.fkArchive
        ? item.fkArchive?.originalExtension
          ? nameSplit + item.fkArchive.originalExtension
          : item.fkArchive?.name
        : "";
      // some browser needs the anchor to be in the doc
      if (link.download) {
        document.body.append(link);
        link.click();
      }
      link.remove();
      // in case the Blob uses a lot of memory
      setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    }
  }, [responseDocDownload]);

  useEffect(() => {
    if (responseDocumentPermissions) {
      setPermissions(responseDocumentPermissions);
    }
  }, [responseDocumentPermissions]);

  const updateFile = (files) => {
    window.scrollTo(0, 0);
    if (files.length > 0) {
      props.updateFile(files);
    }
    setCloseUploadFiles(false);
    setTotalFiles(files);
  };

  /** Folder browse only: same upload flow as the toolbar Upload button (one file at a time). */
  const canDropUpload = !isSearchResults && !isTrash;

  const clickItem = (item, event) => {
    dispatch(getDocumentPermissions(item.fkArchive.id, navigate));
    setTimeout(() => {
      setShowOption(true);
    }, 200);
    setItem(item);
    setSelectedFiles([]);
    props.clickItem(item, event);
    localStorage.setItem("mapPath", JSON.stringify(props.mapPath));
  };

  const doubleClickItemC = (item, evt) => {
    if (isTrash == false) {
      setIsTrash(item == "Trash");
      props.setTrash(item == "Trash");
    }
    if (isTrash == false) {
      setTimeout(() => {
        setShowOption(false);
      }, 200);
      optionMenu("open");
    }
  };

  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(menuAnchorEl);
  const handleMenuClick = (event, file) => {
    console.log("update", file);
    setItem(file);
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    handleMenuClose();
    setShowOption2(open);
    setShowOption(open);
  };

  const closeModal = () => {
    setShowMove(false);
    setShowShare(false);
    setShowRename(false);
    setShowNewFolder(false);
    setShowReprocess(false);
    setShowRecover(false);
  };

  const [open, setOpen] = React.useState(false);
  const [deleteWord, setDeleteWord] = React.useState("");
  const [itemToDelete, setItemToDelete] = React.useState(null);

  const handleOpen = (item) => {
    setItemToDelete(item);
    setDeleteWord("");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDeleteWord("");
    setItemToDelete(null);
  };

  const handleConfirmDelete = () => {
    if (deleteWord === "DELETE") {
      callDelete(itemToDelete);
      //toast.success('Item deleted!');
      handleClose();
    } else {
      toast.error("Wrong Key!");
    }
  };

  const optionMenu = (opt, itemEl) => {
    var itemInfo;
    if (item.fkArchive) {
      itemInfo = item;
    } else {
      itemInfo = itemEl;
    }

    let type = itemInfo.folder ? "Folder" : itemInfo.fkArchive.type;

    switch (opt) {
      case "properties": {
        setShowOption2(true);
        return null;
      }
      case "open": {
        if (type === "Folder") {
          let send = {
            label: itemInfo.fkArchive.name,
            parent: null,
            value: itemInfo.fkArchive.id,
          };
          callItemTree(send);
          setShowOption(false);
        } else {
          props.openFile(itemInfo);
          setShowOption(false);
        }
        return null;
      }
      case "download": {
        let type = itemInfo.fkArchive?.originalExtension
          .toUpperCase()
          .replace(".", "");

        dispatch(
          postDocDownload(
            {
              archiveId: itemInfo.fkArchive.id,
              fileName: itemInfo.fileReferences.originalFileName
                ? itemInfo.fileReferences.originalFileName
                : itemInfo.fkArchive.name,
              type: type,
            },
            navigate
          )
        );
        setShowOption(false);
        return null;
      }
      case "downloadZip": {
        let folderName = itemInfo.fileReferences.originalFileName
          ? itemInfo.fileReferences.originalFileName
          : itemInfo.fkArchive.name;
        let obj = [itemInfo.fkArchive.id];
        dispatch(postFolderDownloadZip(folderName, obj));
        setShowOption(false);
        return null;
      }
      case "move": {
        setShowMove(true);
        setShowOption(false);
        return null;
      }
      case "rename": {
        setShowRename(true);
        setShowOption(false);
        return null;
      }
      case "delete": {
        //        deleteItem(itemInfo);
        handleOpen(itemInfo);
        setShowOption(false);
        return null;
      }
      case "share": {
        setShowShare(true);
        setShowOption(false);
        return null;
      }
      case "reprocess": {
        setShowReprocess(true);
        setShowOption(false);
        return null;
      }
      case "recover": {
        setShowRecover(true);
        setShowOption(false);
        return null;
      }
      case "fileLocation": {
        if (itemInfo.fkArchive.parentArchiveId) {
          const itemToNavigate = {
            label: itemInfo.fkArchive.name,
            value: itemInfo.fkArchive.id,
          };
          backTree(itemToNavigate);
        }
        setShowOption(false);
        return null;
      }
      case "open location": {
        if (itemInfo?.fkArchive?.id) {
          window.location.href = `/explorer/${itemInfo?.fkArchive?.id}`;
        }
        setShowOption(false);
        return null;
      }
      default: {
        return null;
      }
    }
  };
  const deleteItem = (_item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="deleteConfirm custom-ui">
            <h1 style={{ margin: "-43px 0px 0px 0px" }}>Are you sure?</h1>
            <p>
              Write the text "DELETE" in the following box and confirm the
              deletion of the item. The item will be moved to the trash bin and
              remain there for 30 days before being permanently deleted
            </p>

            <TextField
              style={{
                width: "100%",
                backgroundColor: "#fff",
                marginBottom: "26px",
              }}
              id="delete"
              variant="outlined"
              onChange={(e) => (deleteWord = e.target.value)}
              label="Write DELETE"
            />

            <Button className={classes.btnCancel} autoFocus onClick={onClose}>
              NO
            </Button>

            <Button
              className={classes.btnDelete}
              autoFocus
              onClick={() => {
                if (deleteWord === "DELETE") {
                  deleteWord = "";
                  callDelete(_item);
                  onClose();
                } else {
                  toast.error("Wrong Key!");
                }
              }}
            >
              Yes, Delete it!
            </Button>
          </div>
        );
      },
    });
  };

  const callDelete = (_item) => {
    props.deleteFile({ deleteFiles: true, item: _item });
  };

  const setNewTree = (obj) => {
    if (obj === null || obj === undefined) return;
    for (const [k, v] of Object.entries(obj)) {
      obj["hola"] = obj["name"];
      setNewTree(v);
    }
  };

  const callMove = (moveFile) => {
    setShowMove(false);
    props.moveFile();
  };

  const callShare = (shareFiles) => {
    setShowShare(false);
    props.shareFile({ shareFiles: shareFiles, item: item });
  };

  const callRename = (renameFiles) => {
    setShowRename(false);
    props.renameFile();
  };

  const callReprocess = (reprocessFiles) => {
    setShowReprocess(false);
    //props.reprocessFile(reprocessFiles);
  };
  const callRecover = (recoverFiles) => {
    setShowRecover(false);
    //props.recoverFile();
  };

  const callUpdateContent = (content) => {
    setShowRename(false);
    props.updateFile({ updateFile: content, item: item });
  };

  const callAddComment = (comment) => {
    setShowRename(false);
    setShowOption(false);
    props.addComment({ comment: comment, item: item });
  };

  const callItemTree = (item) => {
    props.clickTree(item);
  };

  const backTree = (item) => {
    props.backTree(item);
  };
  const setFileType = (file) => {
    const name = file?.fkArchive?.name;

    if (file.folder || file.fkArchive?.type === "Folder") {
      if (name === "Trash") return folderGray;
      if (name === "Reviewal" || name === "In Progress") return reviewalIcon;
      return iconFolder;
    }

    // Get extension from originalExtension field, fallback to filename if empty
    let extension = file.fkArchive?.originalExtension?.toLowerCase();

    // If originalExtension is empty or not available, extract from filename
    if (!extension || extension === "") {
      const fileName = file.fkArchive?.name || "";
      const lastDotIndex = fileName.lastIndexOf(".");
      if (lastDotIndex > 0) {
        extension = fileName.substring(lastDotIndex).toLowerCase();
      }
    }

    switch (extension) {
      case ".pdf":
        return filePdf;
      case ".doc":
      case ".docx":
        return fileWord;
      case ".xls":
      case ".xlsx":
      case ".csv":
        return fileExcel;
      case ".jpg":
      case ".jpeg":
      case ".png":
        return fileImage;
      case ".zip":
        return fileZip;
      case ".txt":
        return fileDoc;
      default:
        return fileOther;
    }
  };

  const formatFileSize = (sizeInBytes) => {
    if (!sizeInBytes || Number.isNaN(sizeInBytes)) return "-";

    const sizeMB = sizeInBytes / 1_000_000;

    if (sizeMB >= 1000) {
      const sizeGB = sizeMB / 1000;
      return `${sizeGB.toFixed(2)} GB`;
    }

    return `${sizeMB.toFixed(2)} MB`;
  };

  const handleChangePage = (event, newPage) => {
    //let newPage = props.page;
    //newPage = objs.length <= 1 ? 1 : newPage + 1;

    setPage(newPage);
    props.nextPage(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    props.nextPage(0, parseInt(event.target.value, 10));
    setPage(0);
  };

  const clickMap = (item) => {
    props.clickMap(item);
  };

  const getSortIcon = (columnKey) => {
    return "↕️"; // Show neutral sort icon for server-side sorting
  };

  // Context menu handlers for blank area
  const handleContextMenu = (event) => {
    // Only show context menu if clicking on blank area (not on a file/folder)
    const target = event.target;
    const isBlankArea =
      target.classList.contains(classes.scrollListBody) ||
      target.classList.contains(classes.gridContainer) ||
      target.classList.contains(classes.scrollList) ||
      target.closest('[data-blank-area="true"]');

    if (isBlankArea || event.target === event.currentTarget) {
      event.preventDefault();
      setContextMenu({
        mouseX: event.clientX,
        mouseY: event.clientY,
      });
    }
  };

  const handleContextMenuClose = () => {
    setContextMenu(null);
  };

  const handleCreateFolder = () => {
    handleContextMenuClose();
    if (props.onCreateFolder) {
      props.onCreateFolder();
    }
  };

  const handleUploadFiles = () => {
    handleContextMenuClose();
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileInputChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0 && props.onUploadFiles) {
      props.onUploadFiles(files);
    }
    // Reset input so same file can be selected again
    event.target.value = '';
  };

  return (
    <WrapperAllFiles onContextMenu={handleContextMenu} data-blank-area="true">
      {/* Hidden file input for upload */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        multiple
        onChange={handleFileInputChange}
      />

      {/* Context Menu for blank area */}
      <Menu
        open={contextMenu !== null}
        onClose={handleContextMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            minWidth: '180px',
          }
        }}
      >
        <MenuItem onClick={handleCreateFolder} sx={{ py: 1.5 }}>
          <ListItemIcon>
            <CreateNewFolderIcon fontSize="small" sx={{ color: '#0076FF' }} />
          </ListItemIcon>
          <ListItemText primary="New Folder" />
        </MenuItem>
        <MenuItem onClick={handleUploadFiles} sx={{ py: 1.5 }}>
          <ListItemIcon>
            <UploadFileIcon fontSize="small" sx={{ color: '#0076FF' }} />
          </ListItemIcon>
          <ListItemText primary="Upload Files" />
        </MenuItem>
      </Menu>

      <Drawer anchor="bottom" open={showOption2} onClose={toggleDrawer(false)}>
        <div onClick={toggleDrawer(false)} className={classes.closeOpt}>
          CLOSE
        </div>
        <OptionMenuDocPlace
          addComment={callAddComment.bind(this)}
          updateFile={callUpdateContent.bind(this)}
          click={optionMenu.bind(this)}
          item={item}
          isTrash={isTrash}
          permissions={permissions}
          hideFileLocationOption
        />
      </Drawer>
      <div className={classes.scrollList}>
        <RenameDocPlace
          rename={callRename.bind(this)}
          itemRename={item}
          close={closeModal.bind(this)}
          show={showRename}
        />

        <ReprocessDocPlace
          reprocess={callReprocess.bind(this)}
          itemReprocess={item}
          close={closeModal.bind(this)}
          show={showReprocess}
        />

        <RecoverDocPlace
          recover={callRecover.bind(this)}
          itemRecover={item}
          close={closeModal.bind(this)}
          show={showRecover}
        />

        <ShareDocPlace
          share={callShare.bind(this)}
          itemShare={item}
          users={props.users}
          close={closeModal.bind(this)}
          show={showShare}
        />

        <MoveDocPlace
          backTree={backTree.bind(this)}
          treePrevius={props.treePrevius}
          move={callMove.bind(this)}
          tree={props.tree}
          close={closeModal.bind(this)}
          itemMove={item}
          show={showMove}
        />

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogContent>
            <p>
              Write the text <strong>"DELETE"</strong> in the following box and
              confirm the deletion of the item. The item will be moved to the
              trash bin and remain there for 30 days before being permanently
              deleted.
            </p>
            <TextField
              fullWidth
              variant="outlined"
              label="Write DELETE"
              value={deleteWord}
              onChange={(e) => setDeleteWord(e.target.value)}
              style={{ marginTop: 16 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              NO
            </Button>
            <Button onClick={handleConfirmDelete} color="error" autoFocus>
              Yes, Delete it!
            </Button>
          </DialogActions>
        </Dialog>

        {isSearchResults && (
          <div className={classes.searchResultsHeader}>
            {loadingSearch ? (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                <CircularProgress size={16} />
                Searching…
              </span>
            ) : (
              <>Search Results ({props.file.length})</>
            )}
          </div>
        )}

        <div className={classes.breadcrumbRow}>
          <div className={classes.breadcrumbContainer}>
            {props.treePrevius && props.treePrevius.length > 0 && (
              <WrapperPathMapUl
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap",
                  justifyContent: "flex-start",
                  maxWidth: "100%",
                  padding: 0,
                  margin: 0,
                  minWidth: 0,
                }}
              >
                <WrapperPathMapLi
                  onClick={() => props.onBreadcrumbHome?.()}
                  className={classes.breadcrumbLink}
                  style={{ flexShrink: 0 }}
                >
                  <span>Home</span>
                </WrapperPathMapLi>
                <WrapperPathMapSpan style={{ flexShrink: 0 }}>›</WrapperPathMapSpan>
                {mapPath.length > 4 && (
                  <WrapperPathMapLi
                    className="breadcrumb-ellipsis"
                    style={{ flexShrink: 0, cursor: "default" }}
                  >
                    <span>…</span>
                  </WrapperPathMapLi>
                )}
                {(mapPath.length <= 4
                  ? mapPath
                  : mapPath.slice(-4)
                ).map((map, idx, arr) => {
                  const isLast = idx === arr.length - 1;
                  return (
                    <WrapperPathMapLi
                      key={map.id || idx}
                      onClick={() => !isLast && clickMap(map.id)}
                      className={
                        isLast
                          ? `${classes.PathActive} ${classes.breadcrumbCurrent}`
                          : classes.breadcrumbLink
                      }
                      style={isLast ? { cursor: "default" } : {}}
                    >
                      {(idx === 0 && mapPath.length <= 4) ? null : <WrapperPathMapSpan>›</WrapperPathMapSpan>}
                      <HtmlTooltip
                        title={map.name}
                        placement="top"
                        enterDelay={300}
                      >
                        <span className="breadcrumb-text">{map.name}</span>
                      </HtmlTooltip>
                    </WrapperPathMapLi>
                  );
                })}
              </WrapperPathMapUl>
            )}
          </div>
          {!isSearchResults && (
            <TablePagination
              component="div"
              count={
                typeof props.total === "number"
                  ? props.total
                  : props.total?.totalRecords ?? props.file.length
              }
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}
            />
          )}
        </div>
        <div className={classes.float_center}>

          {viewMode === "list" ? (
            <>
              <Dropzone
                onDrop={(accepted) => {
                  if (accepted?.length) updateFile(Array.from(accepted));
                }}
                multiple
                noClick
                noKeyboard
                disabled={!canDropUpload}
              >
                {({ getRootProps, getInputProps, isDragActive }) => (
                  <div
                    className={`${classes.scrollListBody} ${
                      isDragActive ? classes.dropTargetActive : ""
                    }`}
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                <div className={classes.listHeader}>
                  <div className={classes.headerCell}>Name</div>
                  <div className={classes.headerCell}>DocType</div>
                  <div className={classes.headerCell}>Size</div>
                  <div className={classes.headerCell}>Type</div>
                  <div className={classes.headerCell}>Date Added</div>
                  <div className={classes.headerCell}></div>
                </div>
                {/* Inline upload row removed — use top action bar Upload instead */}
                {isSearchResults && loadingSearch ? (
                  <Box
                    sx={{
                      width: "100%",
                      minHeight: 220,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                      color: "#0076FF",
                    }}
                  >
                    <CircularProgress />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Searching{searchQuery ? ` for "${searchQuery}"` : ""}…
                    </Typography>
                  </Box>
                ) : (
                props.file.map((file, idx) => {
                  const isTargetFile = targetFileId && file.fkArchive?.id === targetFileId;
                  
                  const name = file?.fkArchive?.name || "-";
                  const docType =
                    file?.fkArchive?.docType?.name ||
                    file?.fkDoctype?.name ||
                    "No DocType";
                  const type =
                    file?.fkArchive?.originalExtension
                      ?.replace(".", "")
                      .toUpperCase() ||
                    file?.fkArchive?.type ||
                    "-";
                  const isFolder =
                    file?.folder || file?.fkArchive?.type === "Folder";
                  const rawSize = isFolder
                    ? file?.totalContentSize
                    : file?.fkArchive?.size ??
                      file?.size ??
                      file?.fileSize ??
                      file?.fileReferences?.fileSize;
                  const sizeLabel = formatFileSize(rawSize);
                  const dateAdded = formatDate(
                    file?.fkArchive?.createdAt || file?.createdAt
                  );

                  return (
                    <div
                      key={idx}
                      className={`${classes.listItem} ${
                        idx % 2 === 0 ? classes.rowEven : classes.rowOdd
                      } ${isTargetFile ? "target-file-highlight" : ""}`}
                      style={{ cursor: "pointer" }}
                      onClick={(event) => clickItem(file, event)}
                      onDoubleClick={(event) => {
                        if (file.folder) {
                          props.clickTree({
                            label: file.fkArchive.name,
                            value: file.fkArchive.id,
                            parent: file.fkArchive.parentArchiveId,
                          });
                        } else {
                          setItem(file);
                          optionMenu("open", file);
                        }
                      }}
                    >
                      <div className={classes.fileNameContainer}>
                        <img
                          src={setFileType(file)}
                          alt="file-icon"
                          className={classes.listIcon}
                        />
                        <div className={classes.listFileName}>{name}</div>
                      </div>
                      <div className={classes.blueText}>{docType}</div>
                      <div className={classes.blueText}>{sizeLabel}</div>
                      <div className={classes.blueText}>{type}</div>
                      <div className={classes.blueText}>{dateAdded}</div>
                      <div style={{ textAlign: "right" }}>
                        <IconButton onClick={(e) => handleMenuClick(e, file)}>
                          <MoreVertIcon />
                        </IconButton>
                      </div>
                    </div>
                  );
                })
                )}
                  </div>
                )}
              </Dropzone>
              <Menu
                anchorEl={menuAnchorEl}
                open={isMenuOpen}
                onClose={handleMenuClose}
              >
                {[
                  { id: "1", name: "Open", iconImg: openIcon },
                  // { id: "2", name: "DocAssistant", iconImg: docAssistantIcon },
                  { id: "3", name: "Download", iconImg: downloadIcon },
                  { id: "4", name: "Move", iconImg: moveIcon },
                  { id: "5", name: "Share", iconImg: shareIcon },
                  { id: "6", name: "Rename", iconImg: renameIcon },
                  { id: "7", name: "Reprocess", iconImg: reprocessIcon },
                  { id: "8", name: "Properties", iconImg: propertiesIcon },
                  { id: "9", name: "Delete", iconImg: deleteIcon },
                ].map((action) => (
                  <MenuItem
                    key={action.id}
                    onClick={() => {
                      optionMenu(action.name.toLowerCase());
                      handleMenuClose();
                    }}
                  >
                    <img
                      src={action.iconImg}
                      alt={action.name}
                      style={{ width: 16, height: 16, marginRight: 8 }}
                    />
                    {action.name}
                  </MenuItem>
                ))}
              </Menu>
            </>
          ) : (
            <Dropzone
              onDrop={(accepted) => {
                if (accepted?.length) updateFile(Array.from(accepted));
              }}
              multiple
              noClick
              noKeyboard
              disabled={!canDropUpload}
            >
              {({ getRootProps, getInputProps, isDragActive }) => (
            <div
              className={`${classes.gridContainer} ${
                isDragActive ? classes.dropTargetActive : ""
              }`}
              {...getRootProps()}
            >
              <input {...getInputProps()} />
              {/* Inline upload tile removed — use top action bar Upload instead */}
              {isSearchResults && loadingSearch ? (
                <Box
                  sx={{
                    width: "100%",
                    minHeight: 220,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    color: "#0076FF",
                  }}
                >
                  <CircularProgress />
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    Searching{searchQuery ? ` for "${searchQuery}"` : ""}…
                  </Typography>
                </Box>
              ) : (
              props.file.map((file, idx) => {
                const isTargetFile = targetFileId && file.fkArchive?.id === targetFileId;
                
                return (
                <div
                  key={idx}
                  className={isTargetFile ? "target-file-highlight" : ""}
                  onClick={(event) => clickItem(file, event)}
                  onDoubleClick={(event) => {
                    if (file.folder) {
                      props.clickTree({
                        label: file.fkArchive.name,
                        value: file.fkArchive.id,
                        parent: file.fkArchive.parentArchiveId,
                      });
                    } else {
                      setItem(file);
                      optionMenu("open", file);
                    }
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <Container>
                    <ContainerIcon>
                      <IconButton onClick={(e) => handleMenuClick(e, file)}>
                        <MoreVertIcon />
                      </IconButton>
                    </ContainerIcon>
                    <ContainerImg>
                      <Image
                        src={setFileType(file)}
                        title={file.fkArchive?.name}
                        alt={file.fkArchive?.name}
                      />
                    </ContainerImg>

                    <DocumentName>{file.fkArchive?.name}</DocumentName>
                  </Container>
                </div>
                );
              })
              )}
              <Menu
                anchorEl={menuAnchorEl}
                open={isMenuOpen}
                onClose={handleMenuClose}
              >
                {[
                  { id: "1", name: "Open", iconImg: openIcon },
                  // { id: "2", name: "DocAssistant", iconImg: docAssistantIcon },
                  { id: "3", name: "Download", iconImg: downloadIcon },
                  { id: "4", name: "Move", iconImg: moveIcon },
                  { id: "5", name: "Share", iconImg: shareIcon },
                  { id: "6", name: "Rename", iconImg: renameIcon },
                  { id: "7", name: "Reprocess", iconImg: reprocessIcon },
                  {
                    id: "10",
                    name: "Open Location",
                    iconImg: openLocationIcon,
                  },
                  { id: "8", name: "Properties", iconImg: propertiesIcon },
                  { id: "9", name: "Delete", iconImg: deleteIcon },
                ].map((action) => (
                  <MenuItem
                    key={action.id}
                    onClick={() => {
                      optionMenu(action.name.toLowerCase());
                      handleMenuClose();
                    }}
                  >
                    <img
                      src={action.iconImg}
                      alt={action.name}
                      style={{ width: 16, height: 16, marginRight: 8 }}
                    />
                    {action.name}
                  </MenuItem>
                ))}
              </Menu>
            </div>
              )}
            </Dropzone>
          )}
        </div>
      </div>
    </WrapperAllFiles>
  );
}

export default AllFilesDocPlace;
